import { INLINES } from '@contentful/rich-text-types';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { renderRichText } from 'gatsby-source-contentful/rich-text';
import { PropTypes } from 'prop-types';
import React from 'react';

import { toCamelCase } from '../../utils';
import Newsletter from '../Newsletter';
import PodcastsLink from '../PodcastsLink';

const ProductHighlight = ({ columns, product }) => {
  const { image, includeEmailSignup, podcastLinks, text, title } = product;
  return (
    <div className={`product__highlight ${columns === 10 ? 'columns-10' : ''}`}>
      <div className="product__highlight--image">
        <GatsbyImage alt={title} image={getImage(image)} />
      </div>
      <div className="product__highlight--info">
        <h5>{title}</h5>
        <>
          {renderRichText(text, {
            renderNode: {
              [INLINES.HYPERLINK]: (node) => (
                <a
                  data-component-id="product_highlight_link"
                  href={node.data.uri}
                >
                  {node.content[0].value}
                </a>
              ),
            },
          })}
        </>
        {podcastLinks && <PodcastsLink podcasts={podcastLinks} />}
        {includeEmailSignup && (
          <div className="product__highlight--info-subscribe">
            <Newsletter
              fullContent
              group={toCamelCase(title)}
              legal
              placeholder="Enter your email"
            />
          </div>
        )}
      </div>
    </div>
  );
};

ProductHighlight.propTypes = {
  columns: PropTypes.number,
  product: PropTypes.object,
};

export default ProductHighlight;
